// extracted by mini-css-extract-plugin
module.exports = {"container":"editUserForm_container__6ZzTY","welcomeText":"editUserForm_welcomeText__OU_ex","formFieldset":"editUserForm_formFieldset__smvBA","error":"editUserForm_error__qE27T"};